export default {
  SET_SYSTEM_OPTIONS (state, data) {
    state.dataOptions = data
  },
  SET_SYSTEM_OPTION_TYPES (state, data) {
    state.dataOptionTypes = data
  },
  SET_BRAND_GROUPS (state, data) {
    state.brandGroups = data
  },
  SET_CALCULATIONS (state, data) {
    state.calculations = data
  },
  SET_CURRENCIES (state, data) {
    state.currencies = data
  },
  SET_COUNTRIES (state, data) {
    state.countries = data
  },
  SET_CHARGES (state, data) {
    state.chargeProfiles = data
  },
  SET_EX_RATES (state, data) {
    state.exchangeRates = data
  },
  SET_FINANCIAL_CODES (state, data) {
    state.financialCodes = data
  },
  SET_JOB_TYPES (state, data) {
    state.jobTypes = data
  },
  SET_LINE_DESCRIPTOR_PROPERTIES (state, data) {
    state.lineDescriptorProperty = data
  },
  SET_NOTE_DESCRIPTOR_PROPERTIES (state, data) {
    state.noteDescriptorProperty = data
  },
  SET_PARTY_GROUPS (state, data) {
    state.partyGroups = data
  },
  SET_ROLES (state, data) {
    state.roles = data
  },
  SET_PORT_AREAS (state, data) {
    state.portAreas = data
  },
  SET_SERVICE_TYPES (state, data) {
    state.serviceTypes = data
  },
  SET_STATIC_DESCRIPTOR_PROPERTIES (state, data) {
    state.staticDescriptorProperty = data
  },
  SET_TARIFF_DESCRIPTOR_PROPERTIES (state, data) {
    state.tariffDescriptorProperty = data
  },
  SET_USER_GROUPS (state, data) {
    state.userGroups = data
  },
  UPDATE_CACHE (state, { cacheProperty, data }) {
    if (state.hasOwnProperty(cacheProperty)) {
      let item = state[cacheProperty].find(({id}) => id === data.id)
      if (item) {
        for (let prop in data) {
          item[prop] = data[prop]
        }
      } else {
        state[cacheProperty].push(data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/systemoptions/store/mutations.js